import { api } from '~shared/api/origin';

import type { TTopic } from './types';

const topicsApi = api.injectEndpoints({
	endpoints: (build) => ({
		getTopics: build.query<TTopic[], { userId: string; botId: string }>({
			query: ({ userId, botId }) => ({
				url: `/ai/users/${userId}/${botId}/topics`,
			}),
		}),
		initiateTopic: build.mutation<
			undefined,
			{ userId: string; botId: string; topicId: string }
		>({
			query: ({ userId, botId, topicId }) => ({
				url: `/ai/users/${userId}/${botId}/initiate-topic/${topicId}`,
				method: 'POST',
				body: {},
			}),
		}),
	}),
});

export const { useGetTopicsQuery, useInitiateTopicMutation } = topicsApi;
